export default __webpack_public_path__ + "static/ted_vid-a2a61eca0acb21bfe8562fbbae024c85.png";